import { ListingItem } from 'depoto-core/src/models'
import { OptionsConfig } from '../../configs'
import { CoreService } from '../../services'

export abstract class BaseListing {
  listingColumns: ListingItem[]
  totalItems = 0
  currentPage: number
  endPage: number
  sortProp = 'id'
  sortDir = 'desc'
  loading = true
  reloading = true
  refreshInterval: any = null
  storageKey: { type: string; key: string }

  protected constructor(protected core: CoreService) {}

  abstract filter(pageNo: number, sortProp: string, sortDir: string, concat: boolean): void

  switchPage(event: any = null): void {
    this.sortProp = event.sortProp
    this.sortDir = event.sortDir
    if (event) {
      this.filter(event.currentPage, event.sortProp, event.sortDir, event.concat)
    } else {
      this.filter(this.currentPage, this.sortProp, this.sortDir, false)
    }
  }

  getStorageKey(entity) {
    const email: string = this.core.services.storage.getSync(this.core.services.storage.keys.auth.email)
    this.storageKey = {
      key:
        this.core.services.storage.keys.views.baseListing.key +
        '.' +
        this.core.services.storage.keys.views[entity].key +
        '.' +
        email,
      type: 'Object',
    }
  }

  callAction(event: any): void {
    this[event.action](event.item)
  }

  saveViewSettings(viewName: string, data: any): void {
    this.core.services.storage.set(this.core.services.storage.keys.views[viewName], data)
  }

  loadViewSettings(viewName: string): any {
    return this.core.services.storage.getSync(this.core.services.storage.keys.views[viewName])
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  clearFilters(): void {}

  openUrl(entity: any): void {
    window.open(entity.url)
  }

  downloadReport(report: any): void {
    this.core.services.download.downloadDocumentAndShowInNewWindow(report.url)
  }

  startRefreshing(reloadFn = 'filter'): void {
    if (!this.refreshInterval) {
      this.refreshInterval = setInterval(() => {
        this[reloadFn](1)
      }, OptionsConfig.strings.refreshIntervalTimeMS)
    }
  }

  stopRefreshing(): void {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
      this.refreshInterval = undefined
    }
  }
}
